import { TourState, tourDefaultState } from "./reducer";
import { ActionWithPayload } from '..';

// Define action types directly here
export const actionTypes = {
    SET_TOUR: 'SET_TOUR',
    SET_TOUR_COMPLETED: 'SET_TOUR_COMPLETED',
    SET_ACTIVE_TOUR: 'SET_ACTIVE_TOUR',
    RESET_TOUR: 'RESET_TOUR',
    UPDATE_TOUR_STEP: 'UPDATE_TOUR_STEP',  // Define the constant directly here
    SET_TOUR_RUN_STATE: 'SET_TOUR_RUN_STATE',
    CLEAR_TOUR_RUN_STATE: 'CLEAR_TOUR_RUN_STATE',
    CLEAR_TOUR: 'CLEAR_TOUR'
};

export const SetTour = (payload: any): ActionWithPayload<typeof actionTypes.SET_TOUR, any> => {
    return {
        type: actionTypes.SET_TOUR,
        payload,
    };
};

export const setTourCompleted = (tourId: string): ActionWithPayload<typeof actionTypes.SET_TOUR_COMPLETED, string> => {
    return {
        type: actionTypes.SET_TOUR_COMPLETED,
        payload: tourId,
    };
};

export const setActiveTour = (tourId: string | null): ActionWithPayload<typeof actionTypes.SET_ACTIVE_TOUR, string | null> => {
    return {
        type: actionTypes.SET_ACTIVE_TOUR,
        payload: tourId,
    };
};

export const resetTour = (tourId: string): ActionWithPayload<typeof actionTypes.RESET_TOUR, string> => {
    return {
        type: actionTypes.RESET_TOUR,
        payload: tourId,
    };
};

export const updateTourStep = (tourId: string, step: number): ActionWithPayload<typeof actionTypes.UPDATE_TOUR_STEP, {tourId: string, step: number}> => {
    return {
        type: actionTypes.UPDATE_TOUR_STEP,
        payload: {
            tourId,
            step
        },
    };
};

export const setTourRunState = (tourId: string, running: boolean): ActionWithPayload<typeof actionTypes.SET_TOUR_RUN_STATE, {tourId: string, running: boolean}> => {
    return {
        type: actionTypes.SET_TOUR_RUN_STATE,
        payload: {
            tourId,
            running
        },
    };
};

export const clearTourRunState = (): ActionWithPayload<typeof actionTypes.CLEAR_TOUR_RUN_STATE, null> => {
    return {
        type: actionTypes.CLEAR_TOUR_RUN_STATE,
        payload: null,
    };
};

export const clearTour = (): ActionWithPayload<typeof actionTypes.CLEAR_TOUR, null> => {
    return {
        type: actionTypes.CLEAR_TOUR,
        payload: null,
    };
};
